// extracted by mini-css-extract-plugin
module.exports = {"column_reverse":"CollectFromSafePlace_column_reverse__161Nm"};